export const baseData = {
  title: "PROJECT"
}